/**
 * Reference data entry's date-time type.
 * tag: 2748
 * @readonly
 * @enum {number} (int)
 */
export enum ReferenceDataDateType {
  AdmitToTradeRequestDate = 0,
  AdmitToTradeApprovalDate = 1,
  AdmitToTradeOrFirstTradeDate = 2,
  TerminationDate = 3,
}
